import React from 'react'
import PropTypes from 'prop-types'
import Background from 'components/atoms/Background'
import { dateToString, timeToString } from 'utils/dates'
import * as S from './styled'
import { CloudFooter } from 'assets/svg'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { useTheme } from 'styled-components'

const Layout1 = ({ content: generalEvent }) => {
  const { title, date, time, location, description, ilustration } = generalEvent
  const { color } = useTheme()

  if (color === AVAILABLE_BRANDS.CLOUD_LIGHT || generalEvent?.Brand === AVAILABLE_BRANDS.CLOUD_LIGHT) {
    return (
      <S.Container>
        <Background />
        <S.Title>
          <span>{title}</span>
        </S.Title>
        <S.Details>
          {dateToString(date)} {timeToString(time)}
          <br />
          {location}
          <div className='separator'></div>
        </S.Details>
        <S.Description>
          <span>Event Program</span> <br />
          <br />
          {description}
        </S.Description>
        <CloudFooter className='cloud'></CloudFooter>
        <S.Illustration illustration={ilustration} />
      </S.Container>
    )
  }
  if (color === AVAILABLE_BRANDS.CLOUD_DARK || generalEvent?.Brand === AVAILABLE_BRANDS.CLOUD_DARK) {
    return (
      <S.Container>
        <Background />
        <S.Illustration illustration={ilustration} />
        <CloudFooter className='cloud'></CloudFooter>
        <S.Title>
          <span>{title}</span>
        </S.Title>
        <S.Details>
          {dateToString(date)} {timeToString(time)}
          <br />
          {location}
          <div className='separator'></div>
        </S.Details>
        <S.Description>
          <span>Event Program</span> <br />
          <br />
          {description}
        </S.Description>
      </S.Container>
    )
  }
}

Layout1.defaultProps = {
  content: {},
}

Layout1.propTypes = {
  content: PropTypes.object,
}

export default Layout1
